import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {ReactiveFormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {DataService} from '../../services/data.service';
import {takeUntil} from 'rxjs/operators';
import {ConfirmDialogComponent} from '../../private/private.component';
import {MatDialog} from '@angular/material/dialog';
import {ActivitiesTemplate} from '../../interfaces/templates';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from "@angular/material/form-field";


@Component({
    selector: 'app-blueprints',
    standalone: true,
    templateUrl: './blueprints.component.html',
    imports: [
        MatFormFieldModule,
        MatSelectModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule
    ],
    styleUrls: ['./blueprints.component.scss']
})
export class BlueprintsComponent implements OnInit, OnDestroy {

    latestActTemplate$: Observable<ActivitiesTemplate>;
    private unsubscribe$ = new Subject();
    public templateForm: UntypedFormGroup;

    public categories = ['AMM', 'AMS', 'AVT', 'OFI', 'OFE', 'TRI', 'UFT', 'AIM', 'TRE', 'PRI', 'ING', 'IUS', 'SPE', 'CDT', 'INS', 'CMT']
        .sort();

    constructor(private dataService: DataService,
                public dialog: MatDialog,
                private fb: UntypedFormBuilder) {
    }

    get activitiesFormArray(): UntypedFormArray {
        return (this.templateForm.get('activities') as UntypedFormArray);
    }

    ngOnInit(): void {
        this.templateForm = this.fb.group({
            id: null,
            activities: this.fb.array([]),
            latest: true,
            validFrom: new Date(),
            validTo: null
        });

        this.latestActTemplate$ = this.dataService.getLatestActivityBluePrints();

        this.latestActTemplate$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(template => {
                this.activitiesFormArray.clear();
                if (template) {
                    this.templateForm.patchValue(template);
                    for (const act of template.activities) {
                        this.activitiesFormArray.push(this.fb.group(act));
                    }
                }
            });
    }

    public ngOnDestroy() {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }

    submit() {
        const dialogMessage = {confirmMessage: `Are you sure you want to save the new activities blueprints?`};
        const dialogData = {data: dialogMessage, height: '250px', width: '600px', disableClose: true};
        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogData);

        dialogRef.afterClosed().subscribe(choice => {
            if (choice.confirm) {
                const newTemplate = this.templateForm.value;
                console.log('saving...', newTemplate);
                return this.dataService.addLatestActivityBluePrints(newTemplate);
            }
        });
    }

}
